import * as api from "@/api/williams/contractors";
import { queryKeys } from "../../queryKeys";
import { useMutation, useQueryClient } from "react-query";

export function usePinContractor() {
  const queryClient = useQueryClient();

  return useMutation(async (id: string) => {
    await api.togglePinned(id);
    queryClient.invalidateQueries(queryKeys.contractor.list());
  });
}
